<template>
  <b-modal v-model="show" centered title="Financial record note" hide-footer>
    <div class="d-block mx-2">
      {{ note }}
    </div>
  </b-modal>
</template>

<script>
export default {
  emits: ['closeViewNoteModal'],
  props: {
    showViewNoteModal: Boolean,
    note: {
      type: String,
      default: () => ''
    }
  },
  data: () => {
    return {
      show: false
    }
  },
  watch: {
    showViewNoteModal() {
      this.show = this.$props.showViewNoteModal
    },
    show(val) {
      if (!val) {
        this.$emit('closeViewNoteModal')
      }
    }
  }
}
</script>
